import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { tap, delay } from "rxjs/operators";
import { Router } from "@angular/router";
import {
  LoopBackConfig,
  UserBaseApi,
  UserBase,
  AccessToken
} from "src/providers/sdk";

@Injectable()
export class AuthenticationService {
  isLoggedIn = false;
  credentials = {
    email: "",
    password: "",
    rememberMe: false
  };
  token: AccessToken;
  user = new UserBase();

  constructor(public router: Router, private UserBaseApi: UserBaseApi) {
    console.log("AuthenticationService constructor");
    LoopBackConfig.setBaseURL(
      "https://smartedafrica.herokuapp.com"
    );
    LoopBackConfig.setApiVersion("api");
  }
  // store the URL so we can redirect after logging in
  redirectUrl: string;

  checkLocalCredentials() {
    //console.log("checkLocalCredentials");
    var localcredentials = JSON.parse(localStorage.getItem("credentials"));
    if (!localcredentials) return false;
    if (
      !localcredentials.rememberMe ||
      !localcredentials.email ||
      !localcredentials.password
    )
      return false;
    Object.assign(this.credentials, localcredentials);
    //console.log(this.credentials);
    return true;
  }

  saveLocalCredentials(credentials) {
    //console.log("saveLocalCredentials :", credentials);
    localStorage.setItem("credentials", JSON.stringify(credentials));
    //console.log("result : ", this.checkLocalCredentials());
  }

  removeLocalCredentials() {
    //console.log("saveLocalCredentials");
    localStorage.setItem("credentials", JSON.stringify({}));
  }

  checkCredentialsFormat() {
    if (!this.credentials.email || !this.credentials.email.length) return false;
    if (!this.credentials.password || !this.credentials.password.length)
      return false;
    this.credentials.rememberMe = this.credentials.rememberMe || false;
    return true;
  }

  checkLogin() {
    if (this.isLoggedIn) return true;

    //load local credentials
    var credentails = this.checkLocalCredentials();

    //Do a login
    this.login()
      .then(data => {
        this.isLoggedIn = true;
      })
      .catch(err => {
        console.log("Cannot login : ", err);
      });

    //return true for instant access even if login fails
    return credentails ? true : false;
  }

  login(): Promise<any> {
    return new Promise((resolve, reject) => {
      //be sure to have an url to redirect to
      this.redirectUrl = this.redirectUrl || "accueil";

      //check if credentials is well formated
      if (!this.checkCredentialsFormat()) {
        this.isLoggedIn = false;
        reject({
          code: "NO_CREDENTIALS",
          status_code: "403",
          message: "Les identifiants sont requis pour effectuer une connexion"
        });
      } else {
        //save or remove stored crentials by user's choice
        if (this.credentials.rememberMe == true) {
          this.saveLocalCredentials(this.credentials);
        } else {
          this.removeLocalCredentials();
        }

        //login with credentials
        this.UserBaseApi.login(this.credentials).subscribe(
          (token: AccessToken) => {
            //save usefuls
            this.token = token;
            this.user = token.user;

            this.UserBaseApi.find({
              where: { id: this.user.id },
              include: "roles"
            }).subscribe((users: UserBase[]) => {
              if (users.length) this.user = users[0];

              if (this.hasRole("admin", this.user.roles)) {
                this.isLoggedIn = true;
                this.router.navigateByUrl(this.redirectUrl);
                resolve();
              } else {
                this.isLoggedIn = false;
                this.router.navigateByUrl("/");
                reject({
                  code: "NO_AUTHORIZATION",
                  status_code: "403",
                  message: "Autorisations insuffisantes"
                });
              }
            });
          },
          err => {
            reject(err);
          }
        );
      }
    });
  }

  hasRole(role, roles) {
    //console.log("roles", roles);
    for (let r of roles) {
      if (r.name == role) return true;
    }

    return false;
  }

  logout(): void {
    this.removeLocalCredentials();
    this.isLoggedIn = false;

    this.UserBaseApi.logout().subscribe(
      done => {
        //console.log("Successfuly logged out");
      },
      err => {
        console.log("Could not logout to server");
      }
    );

    this.router.navigateByUrl("/");
  }
}
